
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useEffect, useState, useMemo } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import MainLayout from '../../components/layout/MainLayout';
import Navigation from '../../components/layout/Navigation';
import DocsSidebar from '../../components/Docs/DocsSidebar';
import DocsContent from '../../components/Docs/DocsContent';
import DocsToc from '../../components/Docs/DocsToc';
import useTranslation from 'next-translate/useTranslation';
export default function DocsPage() {
    const router = useRouter();
    const { slug } = router.query;
    const { t } = useTranslation();
    const seo = t('common:seo', {}, { returnObjects: true });
    const docs = t('docs:sections', {}, { returnObjects: true }) || [];
    const [sidebarOpen, setSidebarOpen] = useState(false);
    // Ensure docs is an array
    const sections = Array.isArray(docs) ? docs : [];
    // Find current section
    const currentIndex = sections.findIndex((s) => s.slug === slug);
    const currentSection = currentIndex >= 0 ? sections[currentIndex] : null;
    const prevSection = currentIndex > 0 ? sections[currentIndex - 1] : null;
    const nextSection = currentIndex < sections.length - 1 ? sections[currentIndex + 1] : null;
    const schemaData = useMemo(() => {
        if (!currentSection)
            return null;
        return {
            "@context": "https://schema.org",
            "@type": "TechArticle",
            "headline": currentSection.title,
            "description": currentSection.description || seo.docs?.description,
            "author": {
                "@type": "Organization",
                "name": "HFDX"
            },
            "publisher": {
                "@type": "Organization",
                "name": "HFDX",
                "logo": {
                    "@type": "ImageObject",
                    "url": "https://hfdx.xyz/logo.png"
                }
            },
            "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": `https://hfdx.xyz/docs/${slug || ''}`
            }
        };
    }, [currentSection, slug, seo.docs?.description]);
    useEffect(() => {
        setSidebarOpen(false);
    }, [slug]);
    // Handle 404 (shouldn't happen with fallback: false)
    if (!currentSection && slug && sections.length > 0) {
        return (<MainLayout loaded={true} title="Page Not Found | HFDX Docs" description="The requested documentation page could not be found." page="docs_page">
                <Navigation variant="light"/>
                <div className="docs_layout">
                    <DocsSidebar sections={sections} isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)}/>
                    <main className="docs_main">
                        <div className="docs_content_wrapper">
                            <article className="docs_content">
                                <header className="docs_content_header">
                                    <h1>Page Not Found</h1>
                                </header>
                                <div className="docs_prose">
                                    <p>The documentation page you're looking for doesn't exist.</p>
                                </div>
                            </article>
                        </div>
                    </main>
                </div>
            </MainLayout>);
    }
    if (!currentSection) {
        return null;
    }
    return (<MainLayout loaded={true} title={`${currentSection.title} | HFDX Docs`} description={currentSection.description || seo.docs?.description} keywords={seo.docs?.keywords} page="docs_page" alternate={`docs/${slug}`} canonical={`/docs/${slug}`} schemaData={schemaData}>
            <Head>
                <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.css" integrity="sha384-n8MVd4RsNIU0tAv4ct0nTaAbDJwPJzDEaqSD1odI+WdtXRGWt2kTvGFasHpSy3SV" crossOrigin="anonymous"/>
            </Head>

            <Navigation variant="light"/>

            <div className="docs_layout">
                <DocsSidebar sections={sections} isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)}/>

                <main className="docs_main">
                    <div className="docs_content_wrapper">
                        <DocsContent section={currentSection} prevSection={prevSection} nextSection={nextSection}/>
                        <DocsToc content={currentSection.content}/>
                    </div>
                </main>

                <button className="docs_mobile_toggle" onClick={() => setSidebarOpen(true)} aria-label="Open navigation">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="3" y1="12" x2="21" y2="12"></line>
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <line x1="3" y1="18" x2="21" y2="18"></line>
                    </svg>
                </button>
            </div>
        </MainLayout>);
}
export async function getStaticPaths() {
    const docs = require('../../locales/en/docs.json');
    const paths = docs.sections
        .filter((section) => section.slug !== '')
        .map((section) => ({
        params: { slug: section.slug }
    }));
    return {
        paths,
        fallback: false
    };
}
async function getStaticProps() {
    return {
        props: {}
    };
}

    async function __Next_Translate__getStaticProps__1a17ab3f2b9__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/docs/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a17ab3f2b9__ as getStaticProps }
  